import axiosInstance from '../axiosConfigCMS';

export default {
  async getLogin() {
    const response = await axiosInstance.get('/login');
    return response.data;
  },
  async getCategories() {
    const response = await axiosInstance.get('/categories');
    return response.data;
  },
  async getJoin() {
    const response = await axiosInstance.get('/menu-join-links');
    return response.data;
  },
  async getAbout() {
    const response = await axiosInstance.get('/menu-about-links');
    return response.data;
  },
  async getAddress() {
    const response = await axiosInstance.get('/address');
    return response.data;
  },
};
